// Records the most recent tool/route the member visited so the dashboard's
// "Recently Viewed" and "Continue where you left off" panels have something
// to show. Purely client-side (localStorage) — no server round-trip.
export type RecentEntry = { label: string; to: string; at: number };

const KEY = "rt:recent-tools";
const MAX = 8;

export function recordRecent(label: string, to: string) {
  if (typeof window === "undefined") return;
  try {
    const raw = localStorage.getItem(KEY);
    const list: RecentEntry[] = raw ? JSON.parse(raw) : [];
    const filtered = list.filter((r) => r.to !== to);
    filtered.unshift({ label, to, at: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(filtered.slice(0, MAX)));
  } catch {
    // storage disabled — safe no-op
  }
}

export function readRecent(): RecentEntry[] {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as RecentEntry[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
